module.exports = __webpack_public_path__ + "static/desarrollo-10a48300476543c130fb4baf01f5064e.jpg";